import { Crud, httpClient, HttpClient, HttpClientResponse, QueryParameter } from 'lib/HttpClient';
import { v4 as uuid } from 'uuid';
import {
    CUSTOMER_OPERATIONS_LIMIT,
    ICustomerExportOperation,
    ICreateCustomerExportOptions,
    IGetCustomerOperationsParams
} from 'components/customers/export/models';
import { IPagedCollection } from 'lib/api/paging';

class CustomerExportsApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'operations', {
            'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID
        });
    }

    public createExport(options: ICreateCustomerExportOptions) {
        return this.httpClient.post(`${this.api}/users/exports`, {
            headers: {
                'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID,
                'x-pepper-req-nonce': uuid()
            },
            body: options
        });
    }

    public getOperations(
        params?: IGetCustomerOperationsParams
    ): HttpClientResponse<IPagedCollection<ICustomerExportOperation>> {
        const queryParameters: QueryParameter[] = [
            { key: 'limit', value: CUSTOMER_OPERATIONS_LIMIT },
            { key: 'sort', value: '-createdAt' }
        ];
        const { nextKey } = params ?? {};
        if (nextKey) {
            queryParameters.push({ key: 'startKey', value: nextKey });
        }
        return this.httpClient.get(`${this.api}/users/exports/operations`, { queryParameters });
    }

    public async getCustomerExportFile(href: string) {
        return fetch(`${this.api}${href}`, {
            headers: {
                'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID,
                Authorization: `Bearer ${this.httpClient.getToken()}`,
                Accept: 'application/json,text/plain,application/octet-stream,application/javascript'
            }
        });
    }

    public getOperation(id: string): HttpClientResponse<ICustomerExportOperation> {
        return this.get(id);
    }
}

export const customerExportsApi = new CustomerExportsApi(httpClient);
